/**
 * The working name for sending a course to people (S4, 8 Oct 2026). Every screen reads its words
 * from here, so renaming “Launch” is one edit. Never on screen: assign, enrol, audience.
 */
export const W = {
  Launch: 'Launch', launch: 'launch',
  Launches: 'Launches', launches: 'launches',
  Launched: 'Launched', launched: 'launched',
  Launching: 'Launching',
} as const
